// Company registration slice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

export interface IUserSessionInfo {
  name: string;
  email:string;
  profileImage?:string;
  id:string;
  accessToken: string;
  firmId?: string; // Optional, if needed for firm-specific operations, currently single firm per user need to handle multiple firms later
}

// Load initial state from sessionStorage if available
const loadUserSessionFromStorage = (): IUserSessionInfo => {
  try {
    const authInfo = sessionStorage.getItem("auth_info");
    if (authInfo) {
      const parsed = JSON.parse(authInfo);
      return {
        name: parsed.name || "",
        email: parsed.email || "",
        profileImage: parsed.profileImage || "",
        id: parsed.userId || parsed.id || "",
        accessToken: parsed.accessToken || "",
        firmId: parsed.firmId || "",
      };
    }
  } catch (error) {
    console.error("Error loading user session from storage:", error);
  }
  return {
    name: "",
    email: "",
    id: "",
    accessToken: "",
  };
};

const initialState: IUserSessionInfo = loadUserSessionFromStorage();

export const userSessionStateSlice = createSlice({
  name: "userRegistration",
  initialState,
  reducers: {
    createNewUserSession: (
      state,
      action: PayloadAction<IUserSessionInfo>
    ) => {
      const newState = { ...state, ...action.payload };
      // Persist to sessionStorage whenever state is updated
      try {
        sessionStorage.setItem("auth_info", JSON.stringify({
          accessToken: newState.accessToken,
          userId: newState.id,
          firmId: newState.firmId,
          name: newState.name,
          email: newState.email,
          profileImage: newState.profileImage,
        }));
      } catch (error) {
        console.error("Error saving user session to storage:", error);
      }
      return newState;
    },
    updateUserSession: (
      state,
      action: PayloadAction<IUserSessionInfo>
    ) => {
      const newState = { ...state, ...action.payload };
      // Persist to sessionStorage whenever state is updated
      try {
        sessionStorage.setItem("auth_info", JSON.stringify({
          accessToken: newState.accessToken,
          userId: newState.id,
          firmId: newState.firmId,
          name: newState.name,
          email: newState.email,
          profileImage: newState.profileImage,
        }));
      } catch (error) {
        console.error("Error saving user session to storage:", error);
      }
      return newState;
    },
  },
});

export const { createNewUserSession, updateUserSession } = userSessionStateSlice.actions;
export const userSessionStateSelector = (state: RootState) =>
  state.userSessionStateReducer;
export default userSessionStateSlice.reducer;
